import React, { useState, useEffect, useRef, useMemo } from 'react';
import ReactTooltip from 'react-tooltip';
import { useHistory, Link } from "react-router-dom";
import env from "../../env";
import { usePageTour } from "../../components/Common/usePageTour";
import { usePageLocale } from "../../hooks/useLocale";
import { useSearch } from '../../hooks/useSearch';
import { ProfileImage, Image } from '../Common/Image';
import { useMenuItemProps } from '../SideMenu/useMenuItemProps';
import { useCurrentUserHook } from '../Authentication/useUserHook';

const Header = (props) => {

  const {currentUser, getCurrentOrgData} = useCurrentUserHook();
  const [isDark, setIsDark] = useState(false);
  
  const {sideMenuRoute} = useMenuItemProps();

  const history = useHistory();
  const searchInputEl = useRef(null);
  // const [headerItems, setHeaderItems] = useState(header?.options || {})
  const {labelLocale} = usePageLocale(currentUser.current_locale, 'headerFooter');
  const {
    searchButton, searchClick, setSearchButton, 
    clearSearch, onSearchCallback, searchKeyword
  } = useSearch(props.setSearchString, null, searchInputEl);

  /*const [scroll, setScroll] = useState(0)      
  const [isTop, setIsTop] = useState(false) */
  let tour = usePageTour();
  const orgLogo = useMemo(()=> getCurrentOrgData()?.logo ? getCurrentOrgData()?.logo : 'images/logo/cuedlink_logo.svg', [currentUser]);
  
  useEffect(() => {
    ReactTooltip.hide();
    setSearchButton(false);
    if(props.queryParam.search){
      props.setSearchString(props.queryParam.search);   
      setSearchButton(true);
    }else{
      clearSearch();
    }
    
  }, [history.location.pathname])

  useEffect(() => {
    /*timer = null
    searchKeyword = null*/

    /*let unlisten = history.listen((location, action) => {
      if(currentpage !== location.pathname){
        ReactTooltip.hide()
        //clearSearch()
        setSearchButton(false)
      }
    })*/

    //Sep 1
    /*setTimeout(function () {
      tour && tour.init()
    }, 1000)*/

    /*return () => {
      unlisten()
    }*/
  }, []);

  useEffect(()=>{
    let currentUrlParams = new URLSearchParams(window.location.search);
    if(props.searchString !== currentUrlParams.get('search')){
      if(props.searchString){
        currentUrlParams.set('search', props.searchString);
      }else{
        currentUrlParams.delete('search')
      }
      props.history.push(window.location.pathname + "?" + currentUrlParams.toString());
    }
  }, [props.searchString])

  /*const handleChange=(event)=>{
    clearTimeout(timer)
    searchKeyword = event.target.value
    timer = setTimeout(triggerChange, WAIT_INTERVAL)
  }

  const triggerChange = () => {
    props.setSearchString(searchKeyword)
  }*/

  const openFeedback = (e) =>{
    props.history.push(`/feedback?url=${props.location.pathname}`);
  }

  const routeHomePage = () =>{
    sideMenuRoute();
  }

  /*useEffect(() => {
    document.addEventListener("scroll", () => {
      const scrollCheck = window.scrollY < 100
      if (scrollCheck !== scroll) {
        setIsTop(scrollCheck)
        setScroll(scrollCheck)
      }
    })
  },[])*/
  useEffect(() => {
      const saved = localStorage.getItem("Cuedlink-theme");
      const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
      const dark = saved ? saved === "dark" : prefersDark;
      setIsDark(dark);
      document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
  }, []);

  const toggleTheme = () => {
    setIsDark((prev) => {
        const next = !prev;
        document.documentElement.setAttribute("data-theme", next ? "dark" : "light");
        localStorage.setItem("Cuedlink-theme", next ? "dark" : "light");
        return next;
    });
  };

  return (
    <>
      <div id="ct" className="header-container">
        <header className="top-bar">
          <div className="flex wrap justspacebetween aligncenter top-bar-content">
            <div className="flex aligncenter gap-5">
              <span className="logo-bg flex justifycenter aligncenter pointer">
                <span onClick={()=>routeHomePage()} data-tip={labelLocale('lan_page')}>
                  <Image styleName="w-55 w-40-xs" image={orgLogo} alt="cueTree Logo" />
                </span>
              </span>
              <span className="flex justifycenter aligncenter m-l-10 text-white f18"
                data-tip={labelLocale('lan_page')}
                onClick={() => history.goBack()}>
                  <i className="fa fa-arrow-left" />
              </span>
            </div>
            <div className="flex aligncenter pointer">
              <ul className="flex aligncenter menu-xs">
                <li data-tip={labelLocale('search')}>
                  <a id="search_btn" onClick={e => searchClick()} 
                    className="flex m-r-30 m-r-22-xs pos-rel">
                    <i className="fas far fa-search white font-14"/>
                  </a>
                </li>
                <li data-tip={(currentUser?.current_organization?.data?.name || '')}>
                  <a onClick={(e) => props.toggleOrgModal()} className="flex m-r-30 m-r-22-xs">
                    <img src="images/web-icon.png" alt="" />
                  </a>
                </li>
                <li data-tip={labelLocale('notify')}>
                  <Link to="/notifications" className="flex m-r-30 m-r-22-xs pos-rel">
                    <img src="images/notification-icon.png" alt="" />
                    <span className="notification-count-header tcenter f10 brd-100p flex aligncenter justifycenter fw900">
                      {currentUser.notification_count || 0}
                    </span>
                  </Link>
                </li>
                <li data-tip={labelLocale('setting')}>
                  <Link to="/user/profile" 
                    className="flex aligncenter m-r-30 m-r-22-xs user-dropdown-xs">
                      <ProfileImage src={currentUser.profile_image_url}/>
                  </Link>
                </li>
                <li data-tip={labelLocale('theme')}>
                  <a onClick={toggleTheme} className="flex m-r-30 m-r-22-xs">
                    <i
                        className={`fas ${isDark ? 'fa-sun' : 'fa-moon'} white font-22`}
                      />
                  </a>
                </li>
                <li data-tip={labelLocale('menu')} onClick={()=> props.setOpenSideNav(!props.openSideNav)}>
                  <div className="flex m-r-30 m-r-5-xs">
                    <img src="images/menu-icon.png" alt="" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </div>
      
      {searchButton && 
        <div className="search-box flex search-color bg-white shadow-tiny m-b-10">
          <div className="flex-grow">
            <i className="fa fa-search"/>
            <input type="text" className="f18 f16-xss"
              ref={searchInputEl}
              placeholder="Search here.." 
              defaultValue={props.searchString || ''}
              autoFocus onChange={(e)=>onSearchCallback(e)}/>
          </div>
          <div>
            <i className="fas fa-times search-close" onClick={()=>clearSearch()}/>
          </div> 
        </div>
      }
    </>
  )

}

export default Header;